import React, { useCallback, useEffect, useState } from 'react';
import './css/index.scss';
import { useNavigate } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import MyTable from '../../components/MyTable';
import useInputState from '../../helpers/hooks/useInputState';
import PaymentItem from './components/PaymentItem';
import { PAYMENT_FILTERS, PAYMENT_HEADER_COLUMNS, PAYMENT_WIDTHS } from './constants';
import Api from '../../Api';
import sendRequest from '../../helpers/sendRequest';
import MyButton from '../../components/MyButton';

function Payments() {
  const navigate = useNavigate();
  const [payments, setPayments] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useInputState(1);
  const [perPage, setPerPage] = useState(100);
  const [selectedFilter, setSelectedFilter] = useState(PAYMENT_FILTERS[0]);
  const [isInit, setIsInit] = useState(false);
  const [itemsPassed, setItemsPassed] = useState(0);

  const getPayments = async ({ paramsPage, paramsPerPage = perPage, isInitRequired = true }) => {
    if (loading || (isInitRequired && !isInit)) return;

    const params = {
      page: paramsPage,
      per_page: paramsPerPage,
    };

    if (selectedFilter.id !== 'all') {
      params.status = selectedFilter.id;
    }

    const data = await sendRequest({
      request: Api.getPayments,
      payload: params,
      warnErrorText: 'while getting payments',
      setLoading,
    });

    if (data?.status === 'ok') {
      setPayments(data.payments || []);
      setTotal(data.total || 0);
    }
  };

  const TableItemComponent = useCallback((item, index) => (
    <PaymentItem
      key={item._id}
      item={item}
      itemsPassed={itemsPassed}
      widths={PAYMENT_WIDTHS}
      index={index}
    />
  ), [itemsPassed]);

  const handlePage = (newVal) => {
    if (newVal === page) return;
    setPage(newVal);
    getPayments({ paramsPage: newVal });
  };

  const onSettingsClick = () => {
    navigate('/payments/settings');
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);

      if (perPage < 1) {
        setPerPage(1);
        getPayments({ paramsPage: 1, paramsPerPage: 1 });
      } else if (perPage > 100) {
        setPerPage(100);
        getPayments({ paramsPage: 1, paramsPerPage: 100 });
      } else {
        getPayments({ paramsPage: 1 });
      }
    }, 600);

    return () => clearTimeout(timer);
  }, [perPage]);

  useEffect(() => {
    setPage(1);
    getPayments({ paramsPage: 1 });
  }, [selectedFilter]);

  useEffect(() => {
    getPayments({ paramsPage: page, isInitRequired: false });
    setTimeout(() => {
      setIsInit(true);
    }, 500);
  }, []);

  useEffect(() => {
    setItemsPassed((page - 1) * perPage);
  }, [payments, page, perPage]);

  return (
    <div className="payments">
      <PageTitle
        text="Платежи"
        RightComponent={(
          <MyButton
            text="Настройки"
            onClick={onSettingsClick}
          />
        )}
      />
      <MyTable
        filters={PAYMENT_FILTERS}
        perPage={perPage}
        setPerPage={setPerPage}
        selectedFilter={selectedFilter}
        setSelectedFilter={setSelectedFilter}
        headerColumns={PAYMENT_HEADER_COLUMNS}
        Item={TableItemComponent}
        data={payments}
        page={page}
        setPage={handlePage}
        total={total}
        isLoading={loading}
        hideSearch
      />
    </div>
  );
}

export default Payments;
